import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import FinalRound from "./components/FinalRound";
import FirstRound from "./components/FirstRound";
import PoolRewards from "./components/PoolRewards";
import Prize from "./components/Prize";
import React, { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";

import { subscribeToPlayers, clearPlayers } from "./store/playerSlice";
import {
  subscribeToGroups,
  clearState as clearStateGroup,
} from "./store/groupSlice";
import {
  subscribeToUserBetStat,
  clearState as clearStateStat,
} from "./store/betStatsSlice";
import { AppDispatch } from "./store";
import {
  subscribeToUserBuyInLogs,
  clearState as clearUserBuyInLogs,
} from "./store/userBuyInLogsSlice";

function App() {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    const unsubscribeFromGroups = dispatch(subscribeToGroups());
    const unsubscribeFromPlayers = dispatch(subscribeToPlayers());
    const unsubscribeFromUserBetStat = dispatch(subscribeToUserBetStat());
    const unsubscribeToUserBuyInLogs = dispatch(subscribeToUserBuyInLogs());

    return () => {
      unsubscribeFromGroups();
      unsubscribeFromPlayers();
      unsubscribeFromUserBetStat();
      unsubscribeToUserBuyInLogs();

      dispatch(clearStateGroup());
      dispatch(clearPlayers());
      dispatch(clearStateStat());
      dispatch(clearUserBuyInLogs());
    };
  }, [dispatch]);

  const onResize = useCallback(() => {
    const root = document.getElementById("root");
    if (root) {
      root.style.transform = `scale(${document.body.clientWidth / 1600})`;
    }
  }, []);

  useEffect(() => {
    onResize();
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, [onResize]);

  return (
    <div
      className="d-flex flex-column h-100"
      style={{ padding: "48px 48px 60px" }}
    >
      <div className="star-field">
        <div className="layer"></div>
        <div className="layer"></div>
        <div className="layer"></div>
      </div>
      <div className="position-absolute top-0 start-0 end-0 bottom-0">
        <img
          src="/assets/corner.png"
          height={160}
          alt="corner"
          className="m-4 position-absolute start-0 top-0"
        />
        <img
          src="/assets/corner.png"
          height={160}
          alt="corner"
          className="m-4 position-absolute end-0 top-0"
          style={{ transform: "scaleX(-1)" }}
        />
        <img
          src="/assets/corner.png"
          height={160}
          alt="corner"
          className="m-4 position-absolute start-0 bottom-0"
          style={{ transform: "scaleY(-1)" }}
        />
        <img
          src="/assets/corner.png"
          height={160}
          alt="corner"
          className="m-4 position-absolute end-0 bottom-0"
          style={{ transform: "scale(-1, -1)" }}
        />
        <img
          src="/assets/lantern.png"
          height={280}
          alt="lantern"
          className="mx-4 position-absolute start-0 top-0"
        />
        <img
          src="/assets/lantern.png"
          height={280}
          alt="lantern"
          className="mx-4 position-absolute end-0 top-0"
          style={{ transform: "scaleX(-1)" }}
        />
      </div>
      <div className="d-flex flex-column align-items-center flex-fill">
        <img
          className="mb-4 flex-fill"
          src="/assets/cbwc-logo.png"
          height={120}
          alt="logo"
        />
        {/* <div className="mt-4 me-3">
          <img src="/assets/banner.png" width="auto" height={170} alt="logo" />
          <div className="event-date lh-1">20 - 22 december 2024</div>
        </div> */}
      </div>
      <BrowserRouter>
        <Routes>
          <Route path="/first-round" element={<FirstRound />} />
          <Route path="/final-round" element={<FinalRound />} />
          <Route path="/pool-rewards" element={<PoolRewards />} />
          {/* <Route path="/" element={<All />} />
          <Route path="/before" element={<Before />} />
          <Route path="/group-stage" element={<GroupStage />} />
          <Route path="/knockout-1" element={<Knockout1 />} />
          <Route path="/knockout-2" element={<Knockout2 />} />
          <Route path="/final" element={<Final />} />
          <Route path="/after" element={<After />} />
          <Route path="/fixtures-10" element={<Fixtures10 />} />
          <Route path="/fixtures-2" element={<Fixtures2 />} />
          <Route path="/final-round" element={<FinalRound />} /> */}
          <Route path="/prize" element={<Prize />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
